import { Injectable } from '@angular/core';
import { Demographics } from '../models/demographics';
import { Address } from '../models/Address';
import { EmploymentData, EmploymentContact } from '../models/employmentVerification';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ScreeningInvite, Screening, ScreeningLight, ScreeningAdditionalData } from '../models/screeningInvite';
import { ApplicantQuestionService } from './applicant-question.service';
import { UserQuestionService } from './user-question.service';
import { UserInvitation } from '../models/clientLocation';
import { QuestionBaseService } from './question-base.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { ChannelService } from './channel.service';
import { AdverseActionLetter } from '../models/AdverseActionLetter';

@Injectable({
  providedIn: 'root'
})
export class ScreeningService {
  clientLocation: number;
  screeningToken: string;
  screeningType: string;
  userId: number;
  loading: boolean;
  errorMessage : string;
  error :boolean;
  public get questions(): QuestionBaseService {
    if (this.screeningType.toLowerCase() == 'applicant') {
      return this.applicantQuestions
    } else {
      return this.userQuestions;
    }
  }

  constructor(public channels : ChannelService,public http: HttpClient, public applicantQuestions: ApplicantQuestionService, public userQuestions: UserQuestionService, public cook : CookieService, private location : Router) { 
  }

  saveScreening() {
    return this.http.post(this.questions.saveUrl, this.questions.DataModel);
  }

  SaveInvitation(invite: ScreeningInvite) {
    return this.http.post(environment.baseURl + '/api/screening/invite', invite);
  }

  getApplicantInvite(token : string){
    return this.http.get(environment.baseURl + `/api/screening/invite/${token}`)
    
  }

  getInvite(): void {
    this.loading = true;
    this.questions.invitefetched.subscribe((b: any) => {
      if(!b.success){
        if(b.redirect){
          this.location.navigateByUrl(b.redirectUrl);
        }else{
          console.log('err',b)
          this.error = true;
          this.errorMessage = b.err.error;
        }
      }else{
        if(this.questions.DataModel.invitation.canceled){
          this.error = true;
          this.errorMessage = 'This invitation has been canceled.';
        }else{
          localStorage.setItem('STP-JWT', this.questions.DataModel.invitation.jwt)
          // this.channels.start();
          this.cook.set('resIq', this.questions.DataModel.invitation.jwt, 0.02, '/' ,'.residentiq.com'); // Set the JWT token in a cookie so we can forward user over to dashboard.
        }
        
        this.loading = false;
      }
    })
    this.questions.getInvite(this.screeningToken);
  }

  GetScreening(token : string): Observable<Screening> {
    return this.http.get<Screening>(environment.baseURl + `/api/screening/screening/${token}`)
  }

  GetScreeningLight(): Observable<ScreeningLight> {
    return this.http.get<ScreeningLight>(environment.baseURl + `/api/reportdata/light/valid`)
  }
  continue(): boolean {
    return this.questions.moveNext();
  }

  ReleaseReport(token : string){
    return this.http.get<boolean>(environment.baseURl + `/api/screening/invite/release/${token}`)
  }

  FetchScreeningAdditionalData(id: number){
    return this.http.get<ScreeningAdditionalData[]>(environment.baseURl + `/api/reportdata/light/additionaldata/${id}`);
  }

  FetchAALDocumentData(token: string) {
    return this.http.get<AdverseActionLetter>(environment.baseURl + '/api/screening/adverse-action/document/' + token);
  }
}
